/**
 * DevExtreme (esm/__internal/core/r1/runtime/inferno/render_template.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    render
} from "inferno";
import {
    createElement
} from "inferno-create-element";
const getContainer = props => {
    var _props$container, _props$item;
    return (null === (_props$container = props.container) || void 0 === _props$container ? void 0 : _props$container.get(0)) || (null === (_props$item = props.item) || void 0 === _props$item ? void 0 : _props$item.get(0))
};
export function renderTemplate(template, props, _component) {
    setTimeout((() => {
        render(createElement(template, props), getContainer(props))
    }), 0)
}
export const hasTemplate = (name, properties, _component) => {
    const value = properties[name];
    return !!value && "string" !== typeof value
};
